import React, { useState, useEffect, useRef } from 'react';
import Modal                          from 'react-bootstrap/Modal';
import CloseBtn                       from 'assets/icons/Close.svg';
import EmployeeBenefitsService        from 'services/employee-benefits.service';
import GuaranteeLetterService         from 'services/guarantee-letter.service';
import AuthService                    from 'services/auth.service';
import queryString                    from 'query-string';
import RedCheck                       from 'assets/icons/Red Check.svg';
import GreenTick                      from 'assets/icons/Green Tick.svg';
import CancelIcon                     from 'assets/icons/Cancel Icon.svg';
import FileIcon                       from 'assets/icons/Uploaded File.svg';
import moment                         from 'moment';
import { nricOrPassport }             from 'helpers/common.helper';
import ArrowDown                      from 'assets/icons/Arrow Down.svg';
import claimFormPdf                   from 'assets/files/BookDoc EB - Claim and Consent Form.pdf';

export function GuaranteeLetterRequest(props) {
  const currentUser                       = AuthService.getCurrentUser();
  const location                          = AuthService.getPracticeLocation();
  const [show, setShow]                   = useState(false);
  const handleShow                        = () => setShow(true);
  const [sectionOne, setSectionOne]       = useState(true);
  const [sectionTwo, setSectionTwo]       = useState(false);
  const [partOne, setPartOne]             = useState(true);
  const [partTwo, setPartTwo]             = useState(false);
  const [errorIcon, setErrorIcon]         = useState(RedCheck);
  const [errorMsg, setErrorMsg]           = useState('This patient is not entitled for employee benefit.');
  const [errorHeader, setErrorHeader]     = useState('No ID Found');

  const handleClose = () => {
    setShow(false);
    setSectionOne(true);
    setSectionTwo(false);
    setPartOne(true);
    setPartTwo(false);
    setErrorIcon(RedCheck);
    setErrorMsg('This patient is not entitled for employee benefit.');
    setErrorHeader('No ID Found');
    setNricField('');
    setErrorResponse('');
    setInsurerField('');
    setDoctypeField('');
    setNoteField('');
    setAttachedFile([]);
  };

  // Submitting NRIC to API to retrieve employee info.
    const [nricField, setNricField]           = useState('');
    const [nricDisplay, setNricDisplay]       = useState('');
    const [apiData, setApiData]               = useState({});
    const [disabledWalkIn, setDisabledWalkIn] = useState(false);

    const nricNextClick = () => {
      setDisabledWalkIn(true);
      const cleanedNric = nricField.replace(/-/g, '');
      let parameters;
      parameters = queryString.stringify({ nric: cleanedNric });

      // Submit nric & retrieve entitlement
        EmployeeBenefitsService.walkIn(parameters).then(
          (data) => {
            setApiData(data);
            setPartOne(false);
            setPartTwo(true);
            setNricDisplay(nricOrPassport(cleanedNric));
          },
          (error) => {
            if (error.response.status === 401) {
              AuthService.logout();
              window.location.replace('/eb/login');
            }

            if (error.response.data.error === 'No ID found or not entitled') {
              setSectionOne(false);
              setSectionTwo(true);
            } else if (error.response.data.error === 'Doctor specialties not matched with employee entitlements') {
              setErrorMsg('This patient does not have any entitlements here.');
              setErrorHeader('No Entitlements');
              setSectionOne(false);
              setSectionTwo(true);
            }
          }
        );

      setTimeout(() => { setDisabledWalkIn(false) }, 2000);
    }

  // Insurance List.
    const [insurerOptions, setInsurerOptions] = useState([]);
    const [insurerField, setInsurerField]     = useState('');
    const practiceLocation                    = AuthService.getPracticeLocation();

    useEffect(() => {
      let parameters;

      parameters = queryString.stringify({
        practice_location_id: practiceLocation.id
      });

      GuaranteeLetterService.insuranceList(parameters).then(
        (data) => {
          const options = data.insurances.map((hash, index) => {
            return (
              <option key={ index } value={ hash.id }>{ hash.name }</option>
            )
          });

          setInsurerOptions(options);
        },
        (error) => {
          if (error.response.status === 401) {
            AuthService.logout();
            window.location.replace('/eb/login');
          }
        }
      );
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Information after submitting nric.
    const [displayInfoTwo, setDisplayInfoTwo] = useState(<span></span>);

    useEffect(() => {
      const patientInfo = [
        { title: 'Email',       value: apiData?.email },
        { title: 'Full Name',   value: apiData?.name },
        { title: 'Phone',       value: apiData?.phone }
      ];

      var infoList = patientInfo;
      if (infoList.length === 0) { return }

      const byChunks = infoList.reduce((memo, value, index) => {
        if (index % 2 === 0 && index !== 0) memo.push([])
        memo[memo.length - 1].push(value)
        return memo
      }, [[]]);

      const informationRows = byChunks.map((array, index) => {
        return (
          <div className="row" key={ index }>
            <div className="col">
              <p className="text-left text-lightgrey mb-0">{ array[0]?.title }</p>
              <p className="text-left"><b>{ array[0]?.value || '-'  }</b></p>
            </div>

            <div className="col">
              <p className="text-left text-lightgrey mb-0">{ array[1]?.title }</p>
              <p className="text-left"><b>{ array[1] ? (array[1]?.value || '-') : null }</b></p>
            </div>
          </div>
        )
      });

      setDisplayInfoTwo(informationRows);
    }, [apiData]); // eslint-disable-line react-hooks/exhaustive-deps

  // Submit action.
    const refreshGuaranteeLetters             = () => props.handleReload();
    const [doctypeField, setDoctypeField]     = useState('');
    const [noteField, setNoteField]           = useState('');
    const [attachedFile, setAttachedFile]     = useState([]);
    const [submitBtn, setSubmitBtn]           = useState(<button>Submit</button>);
    const [errorResponse, setErrorResponse]   = useState('');
    const [disabledSubmit, setDisabledSubmit] = useState(false);

    useEffect(() => {
      const handleSubmit = () => {
        const formData = new FormData();

        // 2021-08-17 - Reuben says insurer should be optional.
        // if (insurerField.length < 1) {
        //   setErrorResponse('You must select an insurance');
        //   return;
        // }

        if (doctypeField.length < 1) {
          setErrorResponse('You must select a document type');
          return;
        }

        formData.append('guarantee_letter[employee_id]', apiData.claimant_id);
        formData.append('guarantee_letter[visit_date]', moment().format('YYYYMMDD'));
        formData.append('guarantee_letter[practice_location_id]', practiceLocation.id);
        formData.append('guarantee_letter[insurance_id]', insurerField);
        formData.append('guarantee_letter[document_type]', doctypeField);
        formData.append('guarantee_letter[notes]', noteField);
        formData.append('guarantee_letter[approval_status]', 'pending');
        formData.append('guarantee_letter[panel_name]', currentUser.name);
        formData.append('guarantee_letter[location]', location.name);
        formData.append('guarantee_letter[employer_id]', apiData.employer_id);

        if (attachedFile.length > 0) {
          attachedFile.forEach(function(file) {
            formData.append('guarantee_letter[doctor_upload_documents_attributes][][file]', file, file.name);
          });
        }

        setDisabledSubmit(true);

        GuaranteeLetterService.createGuaranteeLetter(formData).then(
          (data) => {
            setErrorIcon(GreenTick);
            setErrorHeader('Guarantee letter registered');
            setErrorMsg('A new guarantee letter has been opened for this employee.');
            setSectionOne(false);
            setSectionTwo(true);
            setTimeout(refreshGuaranteeLetters, 1500);
          },
          (error) => {
            console.log(error.response);

            if (error.response.status === 401) {
              AuthService.logout();
              window.location.replace('/eb/login');
            }
          }
        );

        setTimeout(() => { setDisabledSubmit(false) }, 4000);
      }

      setSubmitBtn(
        <button className="btn btn-danger text-white rounded-pill py-3 px-20" onClick={() => { handleSubmit() }} disabled={ disabledSubmit } >
          Submit
        </button>
      );
    }, [apiData, insurerField, doctypeField, noteField, attachedFile, disabledSubmit]); // eslint-disable-line react-hooks/exhaustive-deps

  // File Upload
    const hiddenFileInput             = useRef();
    const [fileInputs, setFileInputs] = useState(<span></span>);

    const handleFileClick = (event) => {
      hiddenFileInput.current.click();
    };

    const checkFileFormat = (file) => {
      const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];
      setErrorResponse('');

      if (!file) { return }

      if (!allowedTypes.includes(file.type)) {
        setErrorResponse('File type can only be JPEG, JPG, PNG or PDF');
      } else if (file.size > 4000000) {
        setErrorResponse('File size exceeds 4MB');
      } else {
        let allFiles    = attachedFile.slice();
        allFiles.push(file);
        setAttachedFile(allFiles);
      }
    };

    useEffect(() => {
      const removeFileSection = (e, index) => {
        let allFiles    = attachedFile.slice();
        allFiles.splice(index, 1);
        setAttachedFile(allFiles);
      };

      const fileInputFields = attachedFile.map((file, index) => {
        return (
          <div className="file-input-field-section" key={ index }>
            <p className="font-size-4 mt-2 text-danger">
              <img src={ FileIcon } alt="file-icon" className="mr-4" />
              { file.name }
              <img src={ CancelIcon } alt="remove-attachment" className="clickable ml-4 w-em-5" onClick={(e) => removeFileSection(e, index) } />
            </p>
          </div>
        )
      });

      setFileInputs(
        <div className="font-size-6 flex-grow-1 pt-3">
          { fileInputFields }
          <input type="file" onChange={(e) => checkFileFormat(e.target.files[0]) } value="" className="d-none" ref={ hiddenFileInput } />
          <span className="fweight-400 clickable text-danger" onClick={ handleFileClick }>Add File</span>
        </div>
      );
    }, [attachedFile]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div>
      <span className="float-right position-relative font-size-4">
        <button id="request-gl-more-btn" className="btn btn-outline-danger rounded-pill px-4 py-2">
          More Actions
          <img id="request-gl-arrow-down-icon" src={ ArrowDown } alt="arrow-down" className="ml-3" />
        </button>

        <div id="claim-more-actions" className="conditional-display" displayed={ props.moreActions.toString() }>
          <div className="action-child px-4 py-4" onClick={ handleShow }>Request GL</div>

          <a className="action-child d-block text-black px-4 py-4" href={ claimFormPdf } download="BookDoc EB - Claim and Consent Form.pdf">
            Download Claim Form
          </a>
        </div>
      </span>

      <Modal show={ show } onHide={ handleClose } keyboard={ false } size="lg" centered>
        <Modal.Header className="d-block">
          <h3>Request GL Form</h3>

          <button type="button" className="close" onClick={ handleClose }>
            <img src={ CloseBtn } alt="modal-close" />
          </button>
        </Modal.Header>

        <Modal.Body className="d-block">
          <div className="conditional-display" displayed={ sectionOne.toString() }>
            <div className="font-size-8 fweight-400 w-em-26 pt-3 pr-4">Patient Information</div>

            <div className="d-flex">
              <div className="font-size-7 fweight-400 w-em-26 pt-3 pr-4">Patient IC/Passport No.</div>

              <div className="font-size-6 fweight-400 flex-grow-1">
                <span className="conditional-display" displayed={ partOne.toString() }>
                  <input id="nric" name="nric" type="text"
                    value={ nricField }
                    onChange={(e) => setNricField(e.target.value) }
                    className="form-control py-6 px-4 rounded-pill w-100"
                  />
                </span>

                <div className="conditional-display pt-4" displayed={ partTwo.toString() }>
                  { nricDisplay }
                </div>
              </div>
            </div>

            <span className="conditional-display" displayed={ partTwo.toString() }>
              <div className="conditional-display mt-8">
                { displayInfoTwo }
              </div>

              <hr/>

              <div className="conditional-display mt-4">
                <div className="d-flex mb-4">
                  <div className="font-size-7 fweight-400 w-em-26 pt-3 pr-4">Insurer</div>

                  <div className="font-size-6 fweight-400 flex-grow-1">
                    <select className="form-control rounded-pill px-4" value={ insurerField } onChange={(e) => setInsurerField(e.target.value) }>
                      <option>-</option>
                      { insurerOptions }
                    </select>
                  </div>
                </div>

                <div className="d-flex mb-4">
                  <div className="font-size-7 fweight-400 w-em-26 pt-3 pr-4">Document Type</div>

                  <div className="font-size-6 fweight-400 flex-grow-1">
                    <select className="form-control rounded-pill px-4" value={ doctypeField } onChange={(e) => setDoctypeField(e.target.value) }>
                      <option>-</option>
                      <option value="outpatient_specialist">Outpatient Specialist</option>
                      <option value="admission_form">Admission Form</option>
                      <option value="discharge_form">Discharge Form</option>
                    </select>
                  </div>
                </div>

                <div className="d-flex mb-4">
                  <div className="font-size-7 fweight-400 w-em-26 pt-3 pr-4">Note</div>

                  <div className="font-size-6 fweight-400 flex-grow-1">
                    <textarea name="doctor-note" type="area" rows="4"
                      placeholder="Explain the patient's health condition."
                      className="form-control py-3 px-4"
                      value={ noteField }
                      onChange={(e) => setNoteField(e.target.value) }
                      style={{ borderRadius: "1em" }}
                    />
                  </div>
                </div>

                <div className="d-flex mb-4">
                  <div className="font-size-7 fweight-400 w-em-26 pt-3 pr-4">
                    Upload File <span className="fweight-300">(Optional)</span><br/>

                    <span className="font-size-2">
                      File can be in either JPEG, JPG, PNG or PDF formats. <br/>Size limit is 4MB.
                    </span>
                  </div>

                  { fileInputs }
                </div>
              </div>
            </span>

            <div className="text-center mt-20">
              <p className="text-left text-danger fweight-400 mb-6">{ errorResponse }</p>

              <span className="conditional-display" displayed={ partOne.toString() }>
                <button className="btn btn-danger text-white rounded-pill py-3 px-20" onClick={ nricNextClick } disabled={ (!nricField || disabledWalkIn) } >
                  Search
                </button>
              </span>

              <span className="conditional-display" displayed={ partTwo.toString() }>{ submitBtn }</span>
            </div>
          </div>

          <div className="conditional-display text-center" displayed={ sectionTwo.toString() }>
            <img src={ errorIcon } alt="error-check"/>
            <h3 className="text-center text-danger my-6">{ errorHeader }</h3>
            <p className="text-center text-grey mb-10">{ errorMsg }</p>
            <button className="btn btn-danger text-white rounded-pill py-3 px-20" onClick={ handleClose }>OKAY</button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}